import { Box, SxProps } from "@mui/material";
import { Common, Custom } from "components";
import { useTheme } from "contexts";
import { useNavigate } from "react-router-dom";
import { Helpers, Routes } from "utils";

type Props = {
  sx?: SxProps;
  color?: string;
};

export const Logo = (props: Props) => {
  const navigate = useNavigate();
  const { isDark, theme } = useTheme();

  return (
    <Box
      sx={{
        width: {
          xs: 1,
          md: "auto",
        },
        mr: {
          xs: "auto",
          md: "unset",
        },
        ml: {
          xs: "auto",
          md: "unset",
        },
        height: 35,
        maxWidth: 200,
        ...props.sx,
      }}
      className="c-pointer"
      onClick={() => navigate(Routes.home)}
    >
      {isDark && <Common.Image src={Helpers.getImage("logo_dark.png")} />}
      {!isDark && <Common.Image src={Helpers.getImage("logo.png")} />}
    </Box>
  );
};
